module.exports = __webpack_public_path__ + "static/media/arialogo2.8e84c6ef.svg";